import { render, staticRenderFns } from "./NewsDetail.vue?vue&type=template&id=1ecee4f9&scoped=true"
import script from "./NewsDetail.vue?vue&type=script&lang=js"
export * from "./NewsDetail.vue?vue&type=script&lang=js"
import style0 from "./NewsDetail.vue?vue&type=style&index=0&id=1ecee4f9&prod&lang=css"
import style1 from "./NewsDetail.vue?vue&type=style&index=1&id=1ecee4f9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ecee4f9",
  null
  
)

export default component.exports